<script setup>
import { MessagesSquare, MessageCircle } from 'lucide-vue-next'
import Card from './Card.vue'
import CtaButton from './CtaButton.vue'

defineProps({
  // Nulo enquanto a equipe não escreveu nada nesta ordem de serviço.
  message: { type: Object, default: null },
})
</script>

<template>
  <Card title="Mensagens da equipe" :icon="MessagesSquare" link-label="Ver todas" link-href="/suporte">
    <p v-if="!message" class="rounded-lg bg-up-bg p-4 text-sm text-slate-500">
      Ainda não há mensagens da equipe nesta ordem de serviço.
    </p>

    <article v-else class="rounded-lg bg-up-bg p-4">
      <header class="flex items-center gap-3">
        <span
          class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-up-navy text-xs font-bold text-white"
          aria-hidden="true"
        >UP</span>
        <h3 class="font-semibold text-up-navy">{{ message.author }}</h3>
        <time class="ml-auto shrink-0 text-xs text-slate-500">{{ message.at }}</time>
      </header>
      <p class="mt-3 text-sm leading-relaxed text-slate-600">{{ message.text }}</p>
    </article>

    <div class="mt-auto pt-5">
      <CtaButton href="/suporte" :icon="MessageCircle">Falar com a equipe</CtaButton>
    </div>
  </Card>
</template>
